<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-16 23:58:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/cart/components/ListHeader/index.vue
-->
<template>
  <div class="title_con clearfix">
    <img
      :src="isSelect ? selectImg : unSelectImg"
      alt=""
      class="left choose_img"
      @click="isCheckedSingleAll"
    />
    <div class="font12 font_weight500 colo087 title_name left line_height_17">
      {{ title }}
    </div>
    <img
      src="@/assets/common/icon_right_go@2x.png"
      alt=""
      class="left right_go"
    />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    isSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectImg: require("@/assets/login/select@2x.png"),
      unSelectImg: require("@/assets/login/unselect_icon@2x.png"),
      headerSelect: false
    };
  },
  computed: {
    getCartList() {
      return this.$store.getters.getCartList;
    }
  },
  methods: {
    isCheckedSingleAll() {
      // console.log(11111);
      this.$emit("isCheckedSingleAll");
    }
  }
};
</script>
<style lang="less" scoped>
.title_con {
  background: #fff;
  .choose_img {
    width: 18px;
    height: 18px;
    margin: 12px 12px 0;
  }
  .title_name {
    margin-top: 15px;
  }
  .right_go {
    width: 24px;
    margin-top: 10px;
  }
}
</style>
